import { usePage } from '@inertiajs/react';
import { Dictionary } from '@inertiajs/core';

interface TranslationsProps {
    [key: string]: string;
}

interface TranslateProps {
    key: string;
    replacements?: Dictionary<string | number>;
}

export default function useTranslation() {
    const { translations } = usePage().props as { translations: TranslationsProps };

    const replacePlaceholders = (translation: string, replacements: Dictionary<string | number>): string => {
        for (const placeholder in replacements) {
            if (Object.prototype.hasOwnProperty.call(replacements, placeholder)) {
                const value = replacements[placeholder];
                translation = translation.replace(`:${placeholder}`, String(value));
            }
        }
        return translation;
    };

    const translate = (keyOrProps: string | TranslateProps, replacements: Dictionary<string | number> = {}): string => {
        if (keyOrProps == undefined) {
            return '';
        }

        let key: string;
        let finalReplacements: Dictionary<string | number> = {};

        if (typeof keyOrProps === 'string') {
            // key = keyOrProps.toLowerCase();
            key = keyOrProps;
            finalReplacements = replacements;
        } else {
            // key = keyOrProps.key.toLowerCase();
            key = keyOrProps.key;
            finalReplacements = keyOrProps.replacements || {};
        }

        let searchKey = key;
        if (searchKey?.indexOf('.') === -1) {
            searchKey = 'default.' + searchKey;
        }

        let translation = translations[searchKey] || key;
        translation = replacePlaceholders(translation, finalReplacements);

        if (translation !== key) {
            return translation;
        }

        searchKey = 'default.' + key;
        translation = translations[searchKey] || key;
        translation = replacePlaceholders(translation, finalReplacements);

        return translation;
    };

    return { __: translate, t: translate };
};
